import { Injectable } from '@angular/core';
import { filter, take } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import { TranslateService } from '@ngx-translate/core';
import { AllocationViewActionsFacade } from '../allocation-view-actions.facade';
import { AllocationViewDepartureDockModel, AllocationViewSelectedEntityModel } from '../../models';
import { AllocationViewActionInterface } from '../models';
import { Observable } from 'rxjs';
import {
  AllocationViewReleaseFromDockAction,
  AllocationViewReleaseFromDockActionPrepare,
  AllocationViewReleaseFromDockActionSetInitialState,
} from './allocation-view-release-from-dock-action.actions';
import { AllocationViewReleaseFromDockActionState } from './allocation-view-release-from-dock-action.state';

@Injectable({ providedIn: 'root' })
export class AllocationViewReleaseFromDockActionFacade implements AllocationViewActionInterface {
  loaded$: Observable<boolean> = this.store.select(AllocationViewReleaseFromDockActionState.getLoaded);
  dockDeparturePreparedData$: Observable<AllocationViewDepartureDockModel> = this.store.select(
    AllocationViewReleaseFromDockActionState.getDockDeparturePreparedData,
  );

  constructor(
    private allocationViewActions: AllocationViewActionsFacade,
    private translateService: TranslateService,
    private store: Store,
  ) {}

  dockDeparture(dock: AllocationViewDepartureDockModel): void {
    this.allocationViewActions.actionIdentifier$
      .pipe(filter(Boolean), take(1))
      .subscribe(({ type: _type }: AllocationViewSelectedEntityModel) => {
        this.store.dispatch(new AllocationViewReleaseFromDockAction(dock));
      });
  }

  loadAll(): void {
    this.store.dispatch(new AllocationViewReleaseFromDockActionSetInitialState());
    this.allocationViewActions.actionIdentifier$
      .pipe(filter(Boolean), take(1))
      .subscribe(({ identifier }: AllocationViewSelectedEntityModel) => {
        this.store.dispatch(
          new AllocationViewReleaseFromDockActionPrepare(identifier, this.translateService.currentLang),
        );
      });
  }

  setInitialState(): void {
    this.store.dispatch(new AllocationViewReleaseFromDockActionSetInitialState());
  }
}
